import constants from '../../../../constants/constants';
import { appointmentRequestPageTypes } from '../../../../config/app.config';
import { useGetAppointmentTypes } from '../../../App/customize/hooks/useGetAppointmentTypes';
import { useAppointmentLabels } from '../../../App/customize/hooks/useAppointmentLabels';
import {
  COPY_COMM_HISTORY_APPOINTMENT_REQUEST_HEADER_TOOLTIP,
  SEND_MESSAGE_APPOINTMENT_REQUEST_HEADER_TOOLTIP,
} from '../../../../shared/components/table/contextualHelpTooltipContent';

const attachmentIcon = `${process.env.PUBLIC_URL}/img/icons/file-attachment-icon.png`;

const TOOLBAR_PLAIN_HEADER_KEYS = [
  'date',
  'parentFullName',
  'petName',
  'typeTitle',
  'doctorFullName',
];

function withoutHeaderSortAndFilter(headers) {
  return headers.map((head) => {
    if (!TOOLBAR_PLAIN_HEADER_KEYS.includes(head.key)) {
      return head;
    }
    return {
      ...head,
      sortable: false,
      filterable: false,
    };
  });
}

export function useAppointmentRequestsTableHeaders(
  type = appointmentRequestPageTypes.default,
) {
  const { data: appointmentTypes = [] } = useGetAppointmentTypes({
    filter: { used: 1 },
  });
  const labels = useAppointmentLabels();

  const commonHeaders = [
    {
      key: 'date',
      name: 'Date',
      sortable: true,
      filterable: false,
      capitalize: true,
      className: 'date-column',
    },
    {
      key: 'time',
      name: 'Time',
      sortable: false,
      filterable: false,
      capitalize: true,
      className: 'time-column',
    },
    {
      key: 'copyHistory',
      name: 'Copy History',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'comm-copy-history-column',
      headerTooltip: COPY_COMM_HISTORY_APPOINTMENT_REQUEST_HEADER_TOOLTIP,
      headerTooltipClassName: 'lp-info-tooltip',
    },
    {
      key: 'typeTitle',
      name: labels.appointmentType,
      className: 'appointment-type',
      sortable: false,
      filterable: true,
      filterValue: appointmentTypes.map(({ _id, title }) => ({ [_id]: title })),
      capitalize: true,
    },
    {
      key: 'attachments',
      name: 'Attachments',
      imgSrc: attachmentIcon,
      imgAlt: 'File attachment icon',
      className: 'with-icon appointment-request-attachment-column',
      sortable: false,
      filterable: false,
      capitalize: false,
    },
    {
      key: 'message',
      name: 'Message',
      headerTooltip: SEND_MESSAGE_APPOINTMENT_REQUEST_HEADER_TOOLTIP,
      headerTooltipClassName: 'lp-info-tooltip',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'appointment-request-message-column',
    },
    {
      key: 'messageStatus',
      name: 'Reply',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'appointment-request-reply-column',
    },
    {
      key: 'lastMsg',
      name: 'Last Msg',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'appointment-request-last-msg-column',
    },
    {
      key: 'parentFullName',
      name: 'Parent Name',
      className: 'appointment-request-parent-column',
      sortable: true,
      filterable: false,
      capitalize: true,
      link: (row) =>
        `/client-list/profile/${row.parentId}?tab=${constants.QUERY_TAB_PARAMS.parent}`,
    },
    {
      key: 'petName',
      name: 'Pet Name',
      sortable: true,
      filterable: false,
      capitalize: true,
      className: 'appointment-request-pet-column',
      link: (row) =>
        `/client-list/profile/${row.parentId}?tab=${constants.QUERY_TAB_PARAMS.petInfo}&${constants.QUERY_PARAMS.pet}=${row.petId}`,
    },
    {
      key: 'doctorFullName',
      name: 'Doctor',
      sortable: false,
      filterable: true,
      filterValue: [],
      capitalize: true,
      className: 'appointment-request-doctor-column',
    },
    {
      key: 'availabilityInfo',
      name: 'Availability Info',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'appointment-request-availability-column',
    },
    {
      key: 'preferredDate',
      name: 'Specific Date(s)',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'appointment-request-preferred-date-column',
    },
    {
      key: 'condition',
      name: 'Pet Condition',
      sortable: false,
      filterable: false,
      capitalize: false,
      className: 'appointment-request-condition-column',
    },
  ];

  const headersTypes = {
    [appointmentRequestPageTypes.default]: withoutHeaderSortAndFilter(
      commonHeaders,
    ),
    [appointmentRequestPageTypes.clientPageModal]: commonHeaders.filter(
      ({ key }) => key !== 'parentFullName',
    ),
  };

  return headersTypes[type];
}
